
import MetaGlobal from '../types/negocio/MetaGlobal';
import api from './api';
import BaseService from './BaseService';

class MetaGlobalService extends BaseService<MetaGlobal> {  

  constructor() {
    super('meta-global', api);
  }  
 
}

export const metaGlobalService = new MetaGlobalService();